import { createSlice } from '@reduxjs/toolkit';

/**
 * Guided tour (react-joyride) state.
 *
 * Replaces the classic-Redux pair:
 *   - reducers/guidedTourReducer.js
 *   - actions/tourActions.js
 *
 * The old reducer had two latent bugs the migration fixes:
 *   - SET_STEPS read `action.steps` while the action creator wrote
 *     `action.payload.steps`, so steps were never persisted into Redux.
 *   - SET_STEP_INDEX had the same mismatch (`action.stepIndex` vs `payload.stepIndex`).
 *     The localStorage side-effect masked it for the tourStepIndex case only.
 *
 * The slice's reducers consume `action.payload` directly, fixing both. The
 * localStorage write that used to live in the action creator now lives in the
 * `useGuidedTour` hook (reducers stay pure).
 *
 * Slice name `tour` matches the previous store key so existing
 * `useSelector(state => state.tour.…)` calls keep working.
 */
const initialState = {
  run: false,
  stepIndex: Number(localStorage.getItem('tourStepIndex')) || 0,
  steps: [],
  navigationInProgress: false,
};

const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    startTour: (state) => {
      state.run = true;
    },
    stopTour: (state) => {
      state.run = false;
    },
    setSteps: (state, action) => {
      state.steps = action.payload;
    },
    setStepIndex: (state, action) => {
      state.stepIndex = action.payload;
    },
    resetTour: (state) => {
      state.stepIndex = 0;
    },
  },
});

export const { startTour, stopTour, setSteps, setStepIndex, resetTour } = tourSlice.actions;
export default tourSlice.reducer;
